/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UploadComparablePropertyImageResponseDto
 */
export interface UploadComparablePropertyImageResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UploadComparablePropertyImageResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UploadComparablePropertyImageResponseDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof UploadComparablePropertyImageResponseDto
     */
    cdnUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof UploadComparablePropertyImageResponseDto
     */
    caption?: string;
}

/**
 * Check if a given object implements the UploadComparablePropertyImageResponseDto interface.
 */
export function instanceOfUploadComparablePropertyImageResponseDto(value: object): value is UploadComparablePropertyImageResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    return true;
}

export function UploadComparablePropertyImageResponseDtoFromJSON(json: any): UploadComparablePropertyImageResponseDto {
    return UploadComparablePropertyImageResponseDtoFromJSONTyped(json, false);
}

export function UploadComparablePropertyImageResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadComparablePropertyImageResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'url': json['url'],
        'cdnUrl': json['cdnUrl'] == null ? undefined : json['cdnUrl'],
        'caption': json['caption'] == null ? undefined : json['caption'],
    };
}

export function UploadComparablePropertyImageResponseDtoToJSON(json: any): UploadComparablePropertyImageResponseDto {
    return UploadComparablePropertyImageResponseDtoToJSONTyped(json, false);
}

export function UploadComparablePropertyImageResponseDtoToJSONTyped(value?: UploadComparablePropertyImageResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'url': value['url'],
        'cdnUrl': value['cdnUrl'],
        'caption': value['caption'],
    };
}

